export default __webpack_public_path__ + "static/media/support 1.cc64436c.svg";